define('taoQtiItem/qtiXmlRenderer/renderers/Img',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'img',
        template : tpl
    };
});
